import { ToastVariant } from "./ToastVariant";

export const LoginToastMessages = {
  loginError: {
    message: "Login failed",
    variant: ToastVariant.Error,
  },
  twoFactorAuthError: {
    message: "The verification code is incorrect",
    variant: ToastVariant.Error,
  },
};